import {
    getMerchantTransSettings,
    addMerchantTransSettings,
    updateMerchantTransSettings,
    fetchMerchantTransSettingsById,
    getMerchantBankAccountCount,
    fetchMerchantTransSettingsByUser
  } from "../../services/MerchantTransSettingService";
  import {formatSuccess,formatError} from '../../services/commonServices'
  export const MERCHANT_TRANS_SETTINGS_LIST_INITIATED = "MERCHANT_TRANS_SETTINGS_LIST_INITIATED";
  export const MERCHANT_TRANS_SETTINGS_INITIATED = "MERCHANT_TRANS_SETTINGS_INITIATED";
  export const MERCHANT_TRANS_SETTINGS_LIST_LOADED = "MERCHANT_TRANS_SETTINGS_LIST_LOADED";
  export const MERCHANT_TRANS_SETTINGS_LOADED = "MERCHANT_TRANS_SETTINGS_LOADED";
  export const MERCHANT_TRANS_SETTINGS_FAILED = "MERCHANT_TRANS_SETTINGS_FAILED";
  export const MERCHANT_TRANS_SETTINGS_COUNT_INITIATED = "MERCHANT_TRANS_SETTINGS_COUNT_INITIATED";
  export const MERCHANT_TRANS_SETTINGS_COUNT_LOADED = "MERCHANT_TRANS_SETTINGS_COUNT_LOADED";
  export const MERCHANT_TRANS_SETTINGS_COUNT_FAILED  = "MERCHANT_TRANS_SETTINGS_COUNT_FAILED";

  
  export const loadMerchantTransSettings = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_LIST_INITIATED });
      getMerchantTransSettings(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: error.message });
        });
    };
  };

  export const loadMerchantTransSettingsCount = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_COUNT_INITIATED });
      getMerchantBankAccountCount(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_COUNT_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_COUNT_FAILED, payload: error.message });
        });
    };
  };

  

  export const getMerchantTransSettingsById = (id) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_INITIATED });
      return fetchMerchantTransSettingsById(id)
        .then((response) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_LOADED, payload: response.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: formatError(error) });
        });
    };
  };
  
  export const saveMerchantTransSettingsAction = (data, isEdit, id, navigate) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_INITIATED });
      const apiCall = isEdit ? updateMerchantTransSettings(id, data) : addMerchantTransSettings(data);
      return apiCall
        .then((response) => {
          formatSuccess('Merchant Transaction Settings', response.data)
          if(!isEdit){
            setTimeout(()=>{
              navigate('/merchant-transaction-settings');
            },1000)
          }
          else{
            dispatch({ type: MERCHANT_TRANS_SETTINGS_LOADED, payload: response.data.data });
          }
        })
        .catch((error) => {
          if(error && error.response && error.response.data){
            dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: formatError(error.response.data) });
          }
          else{
            dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: formatError(error.message) });
          }
        });
    };
  };

   export const getMerchantTransSettingsByUser = (userId) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_TRANS_SETTINGS_INITIATED });
      return fetchMerchantTransSettingsByUser(userId)
        .then((response) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_LOADED, payload: response.data || response });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_TRANS_SETTINGS_FAILED, payload: formatError(error) });
        });
    };
  };